let Permission = {
  CreateOrders: 1,
  ViewOrders: 2,
  UpdateItems: 3,
  ViewItems: 4,
  UpdateBenchTemplate: 5,
  ViewBenchTemplates: 6,
  CreateUpdateUsers: 7,
  ViewUsers: 8,
  SplitItems: 9,
  ReAssignUniqueNumbers: 10,
  CreateUpdateCollections: 11,
  ViewCollections: 12,
  ViewDashboard: 17,
  MarkOrderAsShipped: 19,
  CancelOrder: 20,
  MarkBenchTemplateAsReadyToBench: 21,
  MarkBenchTemplateAsBenched: 22,
  MarkBenchTemplateAsFinalized: 23,
  AssignEPCEngineerToBenchTemplate: 24,
  AddEditItemDocuments: 26,
  ViewSecurityRoles: 31,
  CreateUpdateSecurityRoles: 32,
  CreateUpdateMiscellaneousItems: 33,
  UpdateOrders: 34,
  CreateUpdateTrackingNumbers: 35,
  ViewBundles: 36,
  CreateUpdateBundles: 37,
  CreateUpdateUsersClientAdmin: 38,
  AddImages: 39,
  ViewAllOrders: 40,
  ViewIinvisionOrders: 41
};

export { Permission }
